import { api } from "@/lib/api";
import { Select, SelectProps, Stack } from "@mantine/core";
import React, { useEffect, useState } from "react";

export interface CountySelectProps extends Omit<SelectProps, 'onChange'> {
    onChange: (value: CountyMask) => void;
};


export interface CountyMask {
    name: string;
    mask: string;
    format: string;
    code: string;
}

const CountySelect: React.FC<CountySelectProps> = ({ onChange, ...rest }) => {
    const [countyMasks, setCountyMasks] = useState<CountyMask[]>([]);
    useEffect(() => {
        const loadCounties = async () => {
            const countyResponse: CountyMask[] = await api.get('config');
            setCountyMasks(countyResponse);
        }
        loadCounties();
    }, []);
    const onSelectionChange = (county: string | null) => {
        if (!county) {
            onChange({ name: '', mask: '', format: '', code: '' });
        }
        const selectedCounty = countyMasks.find((countyMask) => countyMask.name === county);
        if (selectedCounty) {
            onChange(selectedCounty);
        }
    }
    return (
        <Stack gap={0}>
            <Select labelProps={{style: { display: 'none'}}} label="County" {...rest} placeholder="Select a County" onChange={onSelectionChange} data={countyMasks.map((county) => county.name)}  />
        </Stack>
    );
};

export default CountySelect;